import React, {createContext} from 'react';
import cloneDeep from 'lodash/cloneDeep';
import { cLog, cWarn, customLogger } from '../components/igtm/CustomLogger';
import axios from "../utils/axios";
import {getTextContent} from "./TextContent"


import {
    applyDefaultInternationalFlightObject,
    applyDefaultOtherInternationalTravelObject,
    applyStayingAtSchool,
    formatAddressToString,
    getComponentsFromUtcDate,
    getFriendlyAddress,
    getTrainStationIdFromLeg,
    hoursMinFromTime,
    identifyReturnTravelDate,
    processAccademicYearToList
} from "./BookingUtilities";


export const BookingsFlowContext = createContext();

class BookingsFlowContextProvider extends React.Component {


    constructor(props){
        super(props);
        const obj = {

          showQuickEditMobile:false,
          quickEditStudentMobile:false,
          testTravelModeLoading:false,
          testTravelModeData:{},
          fastTrackTrain:false,
          bookingData:{
              foreignOrigin:null,
              foreignDestination:null,
              'direction':'',
              'destination':{
                  destination:{
                      'type':'',
                      'friendlyAddress':''
                  }
              },
              'origin':{
                  destination: {
                      'type': '',
                      'friendlyAddress': ''
                  }
              },
              legs:[]
          },
          dateInfo:null,
          otherDateIntegers:null,
          checkingShareCode:false,
          fastTrackInfill:false,
          fastTrackCoachIgnored:false,
          stayingAtHomeOpen:false,
          legIndex:-1,
          travelDates:{},
          students:{},
          textContent:{},
          drivers:[],
          slideView:'selectDates',
          dvlaLoading:true,
          dvlaError:false,
          flightDataLoading:true,
          flightDataError:false,
          flightDataErrorMsgHook:'',
          homeAddress:{},
          additionalAddresses:[],
          foreignAddresses:[],
          schoolAddressId:false,
          schoolAddresses:[],
          formFields:{},
          additionalDriverTypes:[],
          isLoading: true,
          loadingError:false,
          flightRes:[],
          travelModes:[],
          availableBookers:[],
          catchingOtherEnd:false,
          savingBooking:false,
          bookingSaveSuccess:false,
          selfBook:false,
          studentMode:false,
          localeConfig:{
            dateLocale:'en-GB'
          },
          prevResetState:{},
          resetState:{}
        };

        const {
            studentMode=false,
            ghostContact = false
        } = props;


        if (ghostContact) {
            obj.ghostContact = ghostContact;
        }
        if (studentMode) {
            obj.studentMode = studentMode;
            this.studentMode = studentMode;
        }


        this.state = obj;
        this.defaultState = obj;

    }

    


    componentDidMount(){
        if(this.props.studentMode){
            this.getStudentSetup();
        }
        else{
            this.getTravelDates();
        }
        
    }

    getStudentSetup(){
        this.setState({loadingError:false});
        getTextContent(this);
        const apiPath = `${process.env.REACT_APP_API_URL}/studentbookingsetup`;
        axios.get(apiPath,{
            timeout: 30000,
            withCredentials:true
        }).then(res => {
            const {data:{contacts=[]}} = res;
            // console.log(contacts);
            this.state.availableBookers = contacts;
            this.setSlide('selectParent');
        }).catch(err => {
            customLogger(err);
            this.setState({
                loadingError:true
            })
        });
    }


    getTravelDates(){
        this.setState({loadingError:false})
        getTextContent(this);
        const apiPath = `${process.env.REACT_APP_API_URL}/bookingsetup${this.state.ghostContact ? `/${this.state.ghostContact.id}` : ''}`;
        axios.get(apiPath,{
            timeout: 30000,
            withCredentials:true
        }).then(res => {

            const destinationTypesMap = {};
            for(let i=0; i<res.data.destinationTypes.length; i+=1){
                destinationTypesMap[res.data.destinationTypes[i].flag] = res.data.destinationTypes[i];
            }

            const modeTypesMap = {};
            for(let i=0; i<res.data.travelModes.length; i+=1){
                modeTypesMap[res.data.travelModes[i].mode] = res.data.travelModes[i];
            }

            const newStateObj = {
                setupTime:res.data.timeNow,
                travelDates: res.data.travelDates,
                schoolAddresses: res.data.schoolData.schoolAddresses,
                schoolAddressId: res.data.schoolData.schoolAddresses[0].id,
                additionalAddresses:[],
                foreignAddresses:[],
                students:[],
                additionalDriverTypes:res.data.driverTypes,
                travelModes:res.data.travelModes,
                modeTypesMap,
                destinationTypes:res.data.destinationTypes,
                destinationTypesMap,
                accademicYears:processAccademicYearToList(res.data.accademicYears),
                accademicYearsRaw:res.data.accademicYears,
                bookingMap:res.data.bookingMap,
                isLoading: false
            };

            const userDrivers = [];
            for(let i=0; i<res.data.defaultDrivers.length; i+=1){
                const driverObj = res.data.defaultDrivers[i];
                driverObj.type = 'default';
                userDrivers.push(driverObj);
            }
            for(let i=0; i<res.data.additionalDrivers.length; i+=1){
                const driverObj = res.data.additionalDrivers[i];
                driverObj.label = driverObj.name;
                driverObj.type = 'additional';
                userDrivers.push(driverObj);
            }
            newStateObj.drivers = userDrivers;


            


            const countryStrings = [
                'united kingdom',
                'uk',
                'great britain',
                'england',
                'scotland',
                'wales',
                'northern ireland'
            ];
            for(let i=0; i<res.data.userData.length; i+=1){
                const userData = res.data.userData[i];
                if(userData.studentContactAddresses instanceof Array){
                    for(let i=0; i<userData.studentContactAddresses.length; i+=1) {
                        try {

                            if ((!userData.studentContactAddresses[i].country) || (countryStrings.includes(userData.studentContactAddresses[i].country.toLowerCase())) || res.data.allowInternationalDestination || (userData.studentContactAddresses[i].flag === 'additional')) {
                                if (userData.studentContactAddresses[i].flag === 'home') {
                                    newStateObj.homeAddress = userData.studentContactAddresses[i];
                                    newStateObj.additionalAddresses.push(userData.studentContactAddresses[i]);
                                } else {
                                    newStateObj.additionalAddresses.push(userData.studentContactAddresses[i]);
                                }
                            }
                            else{
                                newStateObj.foreignAddresses.push(userData.studentContactAddresses[i]);
                            }
                        } catch (e) {
                            console.warn(e);
                        }
                    }
                }
                try {
                    if(!newStateObj.homeAddress){
                        if(newStateObj.drivers instanceof Array){
                            for(let i=0; i<newStateObj.drivers.length; i+=1){
                                if(!newStateObj.homeAddress){
                                    if('address' in newStateObj.drivers[i]){
                                        if(newStateObj.drivers[i].address instanceof Array){
                                            for(let j=0; j<newStateObj.drivers[i].address.length; j+=1){
                                                if(countryStrings.includes(newStateObj.drivers[i].address[j].country.toLowerCase())){
                                                    newStateObj.homeAddress = newStateObj.drivers[i].address[j];
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (e) {
                    console.warn(e);
                }

                
                if(userData.studentRelations instanceof Array){
                    for(let i=0; i<userData.studentRelations.length; i+=1) {
                        const studentObj = userData.studentRelations[i].Student;
                        studentObj.isTravelling = false;
                        studentObj.requiresCatering = false;
                        studentObj.studentName = `${studentObj.firstName} ${studentObj.lastName}`;
                        newStateObj.students.push(studentObj);
                    }
                }
            }
            
            if(newStateObj.students.length ===  1){
                newStateObj.students[0].isTravelling = 1;
            }
            

            if(!newStateObj.homeAddress){
                for(let i=0; i<newStateObj.destinationTypes.length; i+=1){
                    if(newStateObj.destinationTypes[i].flag === 'home'){
                        newStateObj.destinationTypes[i].disabled = true;
                    }
                }
            }




            console.log(newStateObj.foreignAddresses);

            this.setState(newStateObj);
            this.setSlide('selectDates');
        }).catch(err => {
            customLogger(err);
            this.setState({
                loadingError:true
            })
        });

    }

    getLeg(){
        return this.getLegById(this.state.legIndex);
    }

    getLegById(id){
        if(id in this.state.bookingData.legs){
            return this.state.bookingData.legs[id];
        }
        return false;
    }

    getLegByIdWithOrigin(id){
        if(id in this.state.bookingData.legs){
            return this.state.bookingData.legs[id];
        }
        if(id === -1){
            return this.state.bookingData.origin;
        }
        if(id === this.state.bookingData.legs.length){
            return this.state.bookingData.destination;
        }
        return false;
    }

    getNoStudentsTravelling(){
        let count = 0;
        for(let i=0; i<this.state.students.length; i+=1){
            if(this.state.students[i].isTravelling){
                count+=1;
            }
        }
        return count;
    }

    setStudentTravelling(id){
        for(let i=0; i<this.state.students.length; i+=1){
            if(this.state.students[i].id === id){
                this.state.students[i].isTravelling = !this.state.students[i].isTravelling;
                break;
            }
        }
        this.setState({
            isLoading:false
        });
    }

    setStudentRequiresCatering(id){
        for(let i=0; i<this.state.students.length; i+=1){
            if(this.state.students[i].id === id){
                this.state.students[i].requiresCatering = !this.state.students[i].requiresCatering;
                break;
            }
        }
        this.setState({
            isLoading:false
        });
    }

    /**
     * @deprecated
     */
    setTravelDateId(id){
        let chosenDate = false;
        for(let i=0; i<this.state.travelDates.length; i+=1){
            if(id === this.state.travelDates[i].id){
                chosenDate =  this.state.travelDates[i];
            }
        }
        if(chosenDate){
            this.setTravelDate(chosenDate);
        }
    }


    setTravelDateCore(chosenDate){
        if(chosenDate){
            const {
                tag='',
                travelDate:{
                    travelDate,
                    directionType:{
                        id:directionId
                    }
                }
            } = chosenDate;
            const {travelDate:travelDateObject} = chosenDate;
            this.state.bookingData.direction = (directionId === 1 ? 'incoming' : 'outgoing');
            this.state.bookingData.dateInfo = travelDateObject;
            this.state.bookingData.date = new Date(travelDate);

            // console.log(chosenDate);
            this.state.bookingData.holidayTag = tag;
        }
    }

    setTravelDate(chosenDate){
        // console.log(chosenDate);
        if(chosenDate){
            this.setTravelDateCore(chosenDate);
            this.setStageAfterTravelDate();
        }
        
    }

    setHolidayId(value){
        this.state.bookingData.holidayTag = value;
        this.setStageAfterTravelDate();

    }

    setAdhocTravelDate(data){
        this.state.bookingData.direction = data.direction;
        this.state.bookingData.directionId = data.directionId;
        this.state.bookingData.date = data.date;
        this.state.bookingData.otherDateIntegers={
            'year':data.date.getFullYear(),
            'month':data.date.getMonth()+1,
            'day':data.date.getDate()
        };



        this.setSlide('selectHoliday');
        
    }

    setStageAfterTravelDate(){
        this.setSchoolAddressId(this.state.schoolAddressId);
        this.setSlide('selectChildren');
    }

    getTravelObjectWithReversal() {
        
        return this.getTravelObject(this.state.catchingOtherEnd);
    }


     setDestinationOrigin(destinationType,reverse=false) {
         if (reverse){
             this.state.catchingOtherEnd = true;
         }
         else{
             this.state.catchingOtherEnd = false;
         }
        const travelObj = this.getTravelObjectWithReversal();

        let slideView = '';
        switch(destinationType){
            case 'home': {
                travelObj.destination.friendlyAddress = formatAddressToString(this.state.homeAddress);
                travelObj.destination.address = this.state.homeAddress;
                if(reverse){
                    slideView = 'directOrLegs';
                }
                else{
                    slideView = 'showOriginDestination';
                }

                break;
            }
            case 'otherDomesticAddress':
                this.applyDefaultAddressObject(travelObj);
                slideView = 'setAdditionalAddress';
                break;
            case 'stayingAtSchool':
                applyStayingAtSchool(travelObj);
                slideView = 'bookingSummary';
                this.setState({stayingAtHomeOpen:true});
                return;
            case 'stayingAtSchoolConfirmed':
                destinationType = 'stayingAtSchool';
                applyStayingAtSchool(travelObj);
                travelObj.destination.type = destinationType;
                slideView = 'bookingSummary';
                this.setState({stayingAtHomeOpen:false});
                break;
            case 'internationalFlight':
                applyDefaultInternationalFlightObject(travelObj);
                slideView = 'internationalFlight';
                break;
            case 'inPersonCollection':
                slideView = 'collectionDropoff';
                break;
            case 'inPersonDropoff':
                slideView = 'collectionDropoff';
                break;
            case 'otherInternationalTravel':
                applyDefaultOtherInternationalTravelObject(travelObj);
                slideView = 'otherInternationalTravel';
                break;
            default:
                console.error('The destination or origin type has not been identified');
        }
        travelObj.destination.type = destinationType;
        // replace with destination type checker
      
        this.setSlide(slideView);
        if(destinationType === 'home' || destinationType === 'otherDomesticAddress') {
            this.setSlide(slideView);
        }
        else{
            this.setSlide(slideView,{testTravelModeData:{}});
        }
    }





    setSchoolAddressId(id){
        let friendlyAddress = '';
        let schoolAddress = {};
        for(let i=0; i<this.state.schoolAddresses.length; i+=1){
            if(`${this.state.schoolAddresses[i].id}` === `${id}`){
                friendlyAddress = this.state.schoolAddresses[i].name;
                schoolAddress = this.state.schoolAddresses[i];
                break;
            }
        }

        if(this.state.bookingData.direction === 'outgoing'){
            this.state.bookingData.origin.destination = {
                'type':'schoolLocation',
                'address': schoolAddress,
                'friendlyAddress': friendlyAddress
            };
        }
        else{
            this.state.bookingData.destination.destination = {
                'type':'schoolLocation',
                'address': schoolAddress,
                'friendlyAddress': friendlyAddress
            };
        }

        this.setState({
            schoolAddressId:id
        })
    }

    setSlide(slideIndex,options={}){
        
        customLogger(`Setting the slide to ${slideIndex}`);
        customLogger(`${this.state.bookingData.legs.length} legs in object, on index ${this.state.legIndex}.`);
        customLogger(this.state.bookingData);
        const slideUpdate = {
            slideView:slideIndex,
            isLoading:false
        };

        const stateUpdate = {...slideUpdate,...options};
        const updatedState = {...this.state,...slideUpdate,...options};



        const prevState = cloneDeep(this.state.resetState);
        

        

        const prevKeys = Object.keys(prevState);
        const newKeys = Object.keys(updatedState);
        const defaultKeys = Object.keys(this.defaultState);
        const doneMap = {};

        
        

        const excludeMap = {
            prevState:true,
            resetState:true
        };
        
        const changeMap = {};

        for(let i=0; i<prevKeys.length; i+=1){
            if(!(prevKeys[i] in excludeMap)){
                if(JSON.stringify(prevState[prevKeys[i]]) !== JSON.stringify(updatedState[prevKeys[i]])){
                    // cLog(`${prevKeys[i]} has changed: ${JSON.stringify(this.state.prevState[prevKeys[i]])} :: ${JSON.stringify(this.state.resetState [prevKeys[i]])}`);
                    changeMap[prevKeys[i]] = cloneDeep(prevState[prevKeys[i]]);
                }
            }
            doneMap[prevKeys[i]] = true;
        }

        for(let i=0; i<defaultKeys.length; i+=1){
            if(!(defaultKeys[i] in excludeMap)){
                if(!(defaultKeys[i] in doneMap)){
                    // cLog(`${newKeys[i]} has been set for the first time`);
                    changeMap[newKeys[i]] = cloneDeep(this.defaultState[newKeys[i]]);
                    doneMap[defaultKeys[i]] = true;
                }
            }
        }

        for(let i=0; i<newKeys.length; i+=1){
            if(!(newKeys[i] in excludeMap)){
                if(!(newKeys[i] in doneMap)){
                    cLog(`${newKeys[i]} has been added`);
                    changeMap[newKeys[i]] = false;
                }
            }
        }
        // changeMap.resetState = prevState.resetState;
        changeMap.prevState = prevState.prevState;

        this.state.resetState = cloneDeep(updatedState);
        this.state.prevState = changeMap;

        customLogger(stateUpdate);

        this.setState(stateUpdate);
    }



    setLegDestination(destinationType,setNewSlide=true){


        const leg = {};
        if(destinationType === 'destination'){
            if((this.state.legIndex+1) in this.state.bookingData.legs){
                // this.state.legIndex+=1;
                this.setState({});
            }
            else{
                leg.destination = this.state.bookingData.destination.destination;
                leg.finalStop = true;
                this.addLeg(leg);
                this.getTravelObject().destination.type = this.state.bookingData.destination.destination.type;
            }
            if(setNewSlide){
                this.travelModeSlideSetup();
            }
            
        }
        else{
            leg.finalStop = false;
            if((this.state.legIndex+1) in this.state.bookingData.legs) {
                this.state.legIndex-=1;
            }

            this.addLeg(leg);
            const travelObj = this.getTravelObject();
            travelObj.destination = {};
            let slideView = '';
            switch(destinationType){
                case 'home': {
                    travelObj.destination.friendlyAddress = formatAddressToString(this.state.homeAddress);
                    travelObj.destination.address = this.state.homeAddress;
                    slideView = 'showOriginDestination';
                    break;
                }
                case 'otherDomesticAddress':
                    this.applyDefaultAddressObject(travelObj);
                    slideView = 'setAdditionalAddress';
                    break;
                case 'trainStation':
                    
                    if(this.testTrainOption(this.state.legIndex-1)){
                        slideView = 'AreYouTakingTheTrainFromHub';
                        break;
                    }

                    if(this.state.fastTrackTrain){
                        travelObj.mode = 'train';
                    }
                    slideView = 'trainStation';
                    break;
                case 'busStation':
                    slideView = 'busStation';
                    break;
                case 'schoolCoachStop':
                    slideView = 'schoolCoachStop';
                    break;
                case 'airport':
                    slideView = 'areYouFlyingDomestic';
                    break;

                default:
                    console.error('The destination or origin type has not been identified');
            }

            travelObj.destination.type = destinationType;
            if(setNewSlide){
                this.setSlide(slideView,{testTravelModeData:{}});
            }
        }

        // console.log(this.getTravelObject());
        // console.log(this.state.bookingData);


    }

    setLegTravelMode(mode) {
        this.state.bookingData.legs[this.state.legIndex].mode = mode;

        switch(mode) {
            case 'privateCar': {
                this.getTravelObject().transportData = {
                    'type':'existing',
                };
                this.setState({
                    isDvlaLoading: true,
                    dvlaError: false,
                });
                this.setSlide('privateCarInput');
                break;
            }
            case 'other': {

                this.setState({

                });
                this.setSlide('otherTransportModeInput');
                break;
            }
            case 'iBookMyTaxi':{
                this.setState({

                });
                this.setSlide('SelfBookTaxiInput');
                break;
            }
            case 'bookMeATaxi':{
                this.setState({

                });

                this.setSlide('FulfilledTaxiInput');
                break;
            }
            case 'publicTransport':{
                this.setState({

                });

                this.setSlide('publicTransportModeInput');
                break;
            }
            case 'train':{
                this.setState({
                    fastTrackTrain:false
                });
                this.setSlide('train');
                break;
            }
            case 'schoolCoach':{
                this.setState({

                });
                this.setSlide('schoolCoachInput');
                break;
            }
            case 'walk':{
                this.setState({

                });
                this.setSlide('walkingModeInput');
                break;
            }

            default:
                // console.log('Transport mode is not recognised');
        }
        // console.log(this.state.bookingData);
    }


    

    getTravelObject(reverse=false){
        console.log('Leg Index: ', this.state.legIndex);
        if(this.state.legIndex === -1){
            if(reverse){
                if(this.state.bookingData.direction === 'outgoing'){
                    // console.log('grabbing the travel object, returning the ultimate destination');
                    return this.state.bookingData.origin;
                }
                // console.log('grabbing the travel object, returning the ultimate origin');
                return this.state.bookingData.destination;
            }
            if(this.state.bookingData.direction === 'outgoing'){
                // console.log('grabbing the travel object, returning the ultimate destination');
                return this.state.bookingData.destination;
            }
            // console.log('grabbing the travel object, returning the ultimate origin');
            return this.state.bookingData.origin;
        }
        // console.log('grabbing the travel object, returning the leg');
        return this.state.bookingData.legs[this.state.legIndex];
    }

    getLegStartAddress(){
        if(this.state.legIndex > -1){
            return this.state.bookingData.legs[this.state.legIndex].destination.friendlyAddress;
        }
        return this.state.bookingData.origin.destination.friendlyAddress;
    }

    getLegEndAddress(){
        try {
            if(this.state.legIndex > -1) {
                return getFriendlyAddress(this.state.bookingData.legs[this.state.legIndex].destination);
            }
            return getFriendlyAddress(this.state.bookingData.destination.destination);
        }
        catch(e){
            // console.log(`error retrieving the end address with leg index ${this.state.legIndex}`);
            return '';
        }
    }



    getFriendlyAddressForPointAtIndex(index){
        // console.log(`Getting friendly address for point at index ${index}`);
        let point = {};
        if(index === -1){
            point = this.state.bookingData.origin.destination;
        }
        else if(this.state.bookingData.legs.length > 0){
            if(index in this.state.bookingData.legs){
                point = this.state.bookingData.legs[index].destination;
            }
            else{
                point = this.state.bookingData.destination.destination;
            }
        }
        else{
            point = this.state.bookingData.destination.destination;
        }
        return getFriendlyAddress(point);
    }


    getPrevLeg(){
        return this.state.bookingData.legs[this.state.legIndex-1];
    }

    setStayingAtHomeOpen(isOpen){
        this.setState({
            stayingAtHomeOpen:isOpen
        })
    }

    getLegOrigin(legIndex=-1){
        let i = legIndex;
        if(i === -1){
            i = this.state.legIndex;
        }

        const preIndex = i-1;
        // console.log(preIndex);
        if(preIndex in this.state.bookingData.legs){
            return this.state.bookingData.legs[preIndex];
        }
        return this.state.bookingData.origin;

    }

    newBooking(){
        cLog('Resetting state');
        
        // get the return traveld ate
        const returnDate = identifyReturnTravelDate(this.state);
        const {
            travelDate:{
                travelDate:tDate = null
            },
            travelDate:newDateInfo = null
        } = returnDate;
        const newBookingDate = new Date(tDate);
        
        let newOrigin = cloneDeep(this.state.bookingData.destination);
        let newDestination = cloneDeep(this.state.bookingData.origin);
        let newSlide = 'showOriginDestination';


        if(this.state.bookingData.destination.destination.type === 'internationalFlight'){
            newOrigin={};
            applyDefaultInternationalFlightObject(newOrigin);
            newOrigin.destination.type = 'internationalFlight';
            newSlide = 'internationalFlight';
        }

        if(this.state.bookingData.origin.destination.type === 'internationalFlight'){
            newDestination={};
            applyDefaultInternationalFlightObject(newDestination);
            newDestination.destination.type = 'internationalFlight';
            newSlide = 'internationalFlight';
        }







        const bookingData = {
                date: newBookingDate,
                dateInfo:newDateInfo,
                destination: newDestination,
                origin: newOrigin,
                direction: 'incoming',
                legs: [],
            }
        // console.log('old booking data', this.state.bookingData);
        this.state.bookingData = {...this.state.bookingData,...bookingData};
        this.state.legIndex = -1; 
        // console.log('new booking data', this.state.bookingData);
        
        


        this.setSlide(newSlide);

        
        // grab the new booking details to get thinsg kick started

    }

    toggleParentBooker(contact){
        if(this.state.ghostContact){
            if(this.state.ghostContact.id === contact.id){
                this.setState({
                    ghostContact:false
                });
                return;
            }
        }
        this.setState({
            ghostContact:contact
        });
           
    }

    checkPrivateTaxiShareCode(code,callback){
        this.setState({checkingShareCode:true});
        const apiPath = `${process.env.REACT_APP_API_URL}/checksharecode`;
        axios.post(apiPath,{
            shareCode:code,
            date:this.state.bookingData.date
        },{
            timeout: 30000,
            withCredentials:true
        }).then(res => {
            this.setState({checkingShareCode:false});
            callback(res.data);
        }).catch(err => {
            this.setState({checkingShareCode:false});
            callback({
                success:false
            });
            customLogger(err);
        });
    }

    lastLegDestinationTime(legIndex){
        const {
            bookingData:{
                dateInfo,
                otherDateIntegers
            }
        } = this.state;
        console.log(legIndex);
        if(legIndex === -1){
            if(this.state.bookingData.direction === 'incoming'){
                if(this.state.bookingData.origin.destination.type === 'internationalFlight'){
                    // set the time to be the arrival time of the flight
                    if(this.state.bookingData.origin.destination.useFlightNo){
                        const {arrivalTime=false,arrivalHoursMin=[]} = this.state.bookingData.origin.destination.flightData;
                        if(arrivalTime){
                            return arrivalTime.date;
                        }
                        const {hours,mins} = arrivalHoursMin;
                        const tDay =  new Date(this.state.bookingData.date);
                        tDay.setHours(hours);
                        tDay.setMinutes(mins); 
                        return tDay;
                    }
                    return this.state.bookingData.origin.destination.additionalAddress.flight_time;
                }
            }
            const tDay =  new Date(this.state.bookingData.date);
            
            if(dateInfo !== null && (otherDateIntegers === null || otherDateIntegers === undefined)){

                const {
                    hours,
                    mins
                } = getComponentsFromUtcDate(dateInfo.departureTime);
                tDay.setHours(hours === 3 ? 12 : hours);
                tDay.setMinutes(mins);
                return tDay;
            }

            tDay.setHours(9);
            tDay.setMinutes(0);
            return tDay;

        }
        try{
            const leg = this.state.bookingData.legs[legIndex];
            switch(leg.mode){
                case 'schoolCoach':{
                    const stopTime = new Date(leg.transportData.route.destinationStop.routeStop.time);
                    const tDay =  new Date(this.state.bookingData.date);
                    tDay.setHours(stopTime.getHours());
                    tDay.setMinutes(stopTime.getMinutes());
                    return tDay;
                }
                case 'train':{
                    return leg.transportData.route.route[leg.transportData.route.route.length-1].arrivalTime;
                }
                case 'flying':{
                    const {
                        transportData:{
                            flightData:{
                                arrivalTime:{
                                    date:arrivalTimeStamp=''
                                } = {}
                            }
                        }
                    } = leg;
                    return arrivalTimeStamp;
                }
                default:{
                    if(dateInfo !== null && otherDateIntegers === null){
                        return dateInfo.departureTime;
                    }
                    const tDay =  new Date(this.state.bookingData.date);
                    tDay.setHours(9);
                    return tDay;
                }
            }
        }
        catch(e){
            cWarn(e);
            return false;
        }
    }


    async testTravelModes(forceLegIndex){
        const cloneBookingData = cloneDeep(this.state.bookingData);
        
        let testLegIndex = this.state.legIndex+1;

        // set the destination
        if(this.state.legIndex > -1){
            testLegIndex = this.state.legIndex;
        }
   

        if(forceLegIndex){
            testLegIndex = forceLegIndex;
        }

        if(!(testLegIndex in cloneBookingData.legs)){
            console.log('adding leg for testing options');
            const leg = {
                destination:this.state.bookingData.destination.destination,
                finalStop:true
            }
            leg.destination.type = this.state.bookingData.destination.destination.type;
            cloneBookingData.legs.push(leg);
        }

        

        

        this.setState({
            testTravelModeLoading: true
        });

        const testData = {
            legIndex:testLegIndex,
            bookingData:cloneBookingData
        };

        // console.log(testData);

        const apiPath = `${process.env.REACT_APP_API_URL}/traveloptions`;
        const res = await axios.post(apiPath,testData,{
            timeout: 30000,
            withCredentials:true
        }).catch(err => {
            // console.log('caught the error');
            this.setState({
                testTravelModeLoading:false
            })
            customLogger(err);
        });
        if(res){
            const testData = res.data;
            testData.testOrigin = (testLegIndex < 1 ? cloneBookingData.origin.destination : cloneBookingData.legs[this.state.legIndex].destination);
            testData.testDestination = cloneBookingData.legs[testLegIndex].destination;
            this.setState({
                testTravelModeData : testData,
                testTravelModeLoading:false
            })
            cLog(this.state.testTravelModeData);
            return res.data;
        }
        cLog(res);
        return false;

    }



    goBack(){
        if(this.state.prevState){
            cLog(this.state.prevState);
            cLog(`Gone back:- Setting the slide back with lightweight backwards hanlding to ${this.state.prevState.slideView}`);
            cLog(`${this.state.bookingData.legs.length} legs in object, on index ${this.state.legIndex}.`);
            const lightWeightPrevState = cloneDeep(this.state.prevState);
            lightWeightPrevState.testTravelModeLoading = false;
            this.setState(lightWeightPrevState);
            return;
        }
  
        cLog(this.state.resetState);
        cLog(`Gone back:- Setting the slide back with lightweight backwards hanlding to reset state`);
        cLog(`${this.state.bookingData.legs.length} legs in object, on index ${this.state.legIndex}.`);
        const lightWeightPrevState = cloneDeep(this.state.prevState);
        lightWeightPrevState.testTravelModeLoading = false;
        this.setState(lightWeightPrevState);
    }

    applyDefaultAddressObject(travelObj){

        let defaultId=0;
        for(let i=0; i<this.state.additionalAddresses.length; i+=1){
            defaultId = this.state.additionalAddresses[i].id;
            break;
        }
        travelObj.destination = {
            useExistingAddress:true,
            addressId:defaultId
        };
    }



    async travelOptionChecks(){
        const apiPath = `${process.env.REACT_APP_API_URL}/traveloptions`;

        this.prepareBookingData();

        const pData = {
            legIndex:this.state.legIndex,
            bookingData:this.state.bookingData,
            exactMatch:true
        };
        const res = await axios.post(apiPath,pData,{
            timeout: 30000,
            withCredentials:true
        }).catch(err => {
            // console.log(`Caught the error: ${apiPath}`);
            // console.log(pData);
            customLogger(err);
        });
        if(res){
            cLog(res.data);
            return res.data;
        }
        return false;
    }

    async travelModeSlideSetup(){
        const modeOptions = await this.travelOptionChecks();

        const testData = modeOptions;
        


        if(modeOptions) {
            /* eslint-disable */
            for (let i = 0; i < this.state.travelModes.length; i += 1) {
                if (this.state.travelModes[i].disabledCheck) {
                    if (this.state.travelModes[i].disabledCheck in modeOptions) {
                        this.state.travelModes[i].isDoable = modeOptions[this.state.travelModes[i].disabledCheck].isDoable;
                    } else {
                        this.state.travelModes[i].isDoable = false;
                    }
                } else {
                    this.state.travelModes[i].isDoable = true;
                }
                //
            }
            /* eslint-enable */
        }
        cLog(modeOptions);
        this.setSlide('setTravelMode',{modeOptions,...{testTravelModeData:modeOptions}});
    }



    isDriverDataComplete(){
        if(this.state.bookingData.legs[this.state.legIndex].driver.type !== 'existing'){
            if(this.state.bookingData.legs[this.state.legIndex].driver.additionalName === ''){
                return false;
            }
        }
        return true;
    }

    confirmCarReg(reg){
        // this sends the information to the dvla for checking
        const apiPath = `${process.env.REACT_APP_API_URL}/dvla/${reg}`;

        axios.get(apiPath,{
            timeout: 30000,
            withCredentials:true
        }).then(res => {
            if('dvlaError' in res.data){
                this.setState({
                    dvlaError:true
                });
            }
            else{
                if(!('transportData' in this.getLeg())){
                    this.state.bookingData.legs[this.state.legIndex].transportData = {};
                }
                this.state.bookingData.legs[this.state.legIndex].transportData.vehicleData = res.data


            }
            this.setState({
                isDvlaLoading:false,
            })
            // console.log(this.state.bookingData);
        }).catch(err => {
            // console.log('caught the error');
            customLogger(err);
        });
    }

    toggleDriverType(){
        this.getLeg().transportData.type = (this.getLeg().transportData.type === 'existing' ? 'additional' : 'existing');
        this.setState({});
    }

    addLeg(leg,addIndex=true){
        this.state.bookingData.legs.splice(this.state.legIndex+1,0,leg);
        // console.log(this.state.bookingData.legs);
        if(addIndex){
            this.state.legIndex+=1;
        }
        
    }

    rewindLeg(){
        this.state.bookingData.legs.pop();
        this.state.legIndex-=1;

        this.setSlide('directOrLegs');
    }

    


    isLegOrigin(){
        return ((this.state.legIndex === -1) && this.state.bookingData.direction === 'outgoing');
    }

    isLegDestination(){
        return ((this.state.legIndex === (this.state.bookingData.legs.length - 1)) && this.state.bookingData.direction === 'incoming');
    }

    finaliseLeg(legIndex=-10) {
        /* eslint-disable */
        if(legIndex !== -10){
            this.state.legIndex = legIndex;
        }
       
         /* eslint-enable */
        // this currently acts as a fast forward, moving through to legs requiring info
        
        try {
            cLog(`This is the fast forward method on index ${this.state.legIndex}`);
            let found = false;
            while (found === false) {
                cLog(`Looping leg index ${this.state.legIndex}`);
                if (this.getTravelObject().finalStop) {
                    cLog('on to the final stop')
                    this.setSlide('bookingSummary');
                    found = true;
                } else if (this.getTravelObject().destination.type && this.getTravelObject().mode && ((this.state.legIndex+1) in this.state.bookingData.legs)) {
                    cLog(`Moving on from index. ${this.state.legIndex}`);
                    this.state.legIndex += 1;
                    this.setState({

                    });
                }
                else if (this.testTrainOption()) {

                    this.setSlide('AreYouTakingTheTrain');
                    found = true;
                }
                else {
                    /* eslint-disable */
                    if(((this.state.legIndex+1) in this.state.bookingData.legs)){
                        this.setSlide('directOrLegs');    
                        found = true;
                    }
                    else{
                        this.testTravelModes(this.state.legIndex+1);
                        this.setSlide('directOrLegs');
                        found = true;
                    }
                     /* eslint-enable */
                    
                }
            }
        }
        catch(e){
            // console.log(this.getTravelObject());
            cWarn(e);
        }
    }



    testTrainOption(legIndex){
        /* eslint-disable */
        const legI = legIndex ? legIndex : this.state.legIndex;
        const leg = this.getLegByIdWithOrigin(legI);
        /* eslint-enable */
        if(leg){
            if(leg.mode !== 'train'){
                // console.log(this.getLegByIdWithOrigin(legI));
                return getTrainStationIdFromLeg(this.getLegByIdWithOrigin(legI));
            }
        }
        return false;
    }

    testFlyingOption(){
        /* eslint-disable */
        const fromIndex = this.state.legIndex-1;
        const toIndex = this.state.legIndex+1;

        const output = {
            from:{
                airport:'',
                airportCode:'',
                airportTerminal:'',
                doable:false
            },
            to:{
                airport:'',
                airportCode:'',
                airportTerminal:'',
                doable:false
            },
        };

        // test from first



        /* eslint-enable */
        if(this.getLegByIdWithOrigin(fromIndex)){
            // console.log(this.getLegByIdWithOrigin(legI));
            const testLeg = this.getLegByIdWithOrigin(fromIndex);
            cLog(`Testing the from leg with index: ${fromIndex}`);
            cLog(testLeg);

            try{
                const {
                    destination:{
                        type='',
                        flightData={}
                    }
                } = testLeg;

                if(type === 'airport' || type ===  'internationalFlight'){
                    const {
                        arrivalAirport:airport='',
                        arrivalAirportCode:airportCode='',
                        arrivalAirportTerminal:airportTerminal='',
                    } = flightData;
                    const airportData = {
                        airport,
                        airportCode,
                        airportTerminal,
                        doable:true
                    }
                    output.from = {...output.from,...airportData};
                }
            }
            catch(e){
                console.warn(e);
            }
        }
        if(this.getLegByIdWithOrigin(toIndex)){
            // console.log(this.getLegByIdWithOrigin(legI));
            const testLeg = this.getLegByIdWithOrigin(toIndex);
            cLog(`Testing the to leg with index: ${toIndex}`);
            cLog(testLeg);
            try{
                const {
                    destination:{
                        type='',
                        flightData={}
                    }
                } = testLeg;

                if(type === 'airport' || type ===  'internationalFlight'){

                    const {
                        departureAirport:airport='',
                        departureAirportCode:airportCode='',
                        departureAirportTerminal:airportTerminal='',
                    } = flightData;

                    const airportData = {
                        airport,
                        airportCode,
                        airportTerminal,
                        doable:true
                    }
                    output.to = {...output.to,...airportData};
                }
            }
            catch(e){
                console.warn(e);
            }
        }

        return output;
    }

    prepareBookingData(){
        if(this.state.bookingData.legs.length > 0){
            for(let i=0; i<this.state.bookingData.legs.length; i+=1){
                if('transportData' in this.state.bookingData.legs[i]){
                    if('travelTime' in this.state.bookingData.legs[i].transportData){
                        if(this.state.bookingData.legs[i].transportData.travelTime){
                            this.state.bookingData.legs[i].transportData.hoursMin = hoursMinFromTime(this.state.bookingData.legs[i].transportData.travelTime);
                        }
                        
                    }
                    if('driverData' in this.state.bookingData.legs[i].transportData){
                        if('travelTime' in this.state.bookingData.legs[i].transportData.driverData){
                            if(this.state.bookingData.legs[i].transportData.driverData.travelTime){
                                this.state.bookingData.legs[i].transportData.driverData.hoursMin = hoursMinFromTime(this.state.bookingData.legs[i].transportData.driverData.travelTime);
                            }
                            
                        }
                    }
                }
                if('travelTime' in this.state.bookingData.legs[i].destination){
                    if(this.state.bookingData.legs[i].destination.travelTime){
                        this.state.bookingData.legs[i].destination.hoursMin = hoursMinFromTime(this.state.bookingData.legs[i].destination.travelTime);
                    }
                    
                }
            }
        }
        if(this.state.bookingData.origin.destination.travelTime){
            this.state.bookingData.origin.destination.hoursMin = hoursMinFromTime(this.state.bookingData.origin.destination.travelTime);
        }
        if(this.state.bookingData.destination.arrivalTime){
            this.state.bookingData.destination.hoursMin = hoursMinFromTime(this.state.bookingData.destination.arrivalTime);
        }
        if(this.state.bookingData.destination.destination.travelTime){
            this.state.bookingData.destination.destination.hoursMin = hoursMinFromTime(this.state.bookingData.destination.destination.travelTime);
        }
    }




    saveBooking(preAuthorize = false) {
        const apiPath = `${process.env.REACT_APP_API_URL}/storebooking${this.state.ghostContact ? `/${this.state.ghostContact.id}` : ''}`;

        this.prepareBookingData();

        this.setState({ savingBooking: true });
        const payload = {
            students: this.state.students,
            preAuthorize,
            bookingData: this.state.bookingData,
            timeOffset: (new Date()).getTimezoneOffset()
        };

        return axios.post(apiPath, payload, {
            timeout: 30000,
            withCredentials: true
        }).then((res) => {
            let success = false;
            if (res.data.success === true) {
                success = true;
            }

            this.setState({
                savingBooking: false,
                saveBookingSuccess: success
            });

            return success;
        });
    }

    userConfirmAction(preAuthorize,rebook = false) {
        return this.saveBooking(preAuthorize).then((success) => {
            if (success && !rebook) {
                this.setSlide('bookingConfirmed');
            }
        });
    }

    testedTravelCoaches(){
        try {
            return this.state.testTravelModeData.canLegDoSchoolCoach.isDoable;
        }
        catch(e){
            // console.log(this.state.testTravelModeData);
            // console.log(e);
            return false;
        }
    }

    takeTheTrainFastTrack(id,addLeg){
        if(id){
            if(addLeg){
                const leg = {};
                leg.destination = this.state.bookingData.destination.destination;
                leg.finalStop = true;
                this.addLeg(leg);
            }
            
            this.setLegTravelMode('train');
        }
        else{
            this.state.fastTrackTrain = true;
            this.setLegDestination('trainStation');
            // console.log(`We are taking the train on leg index ${this.state.legIndex}`);
        }




        
    }


    updateMobileNumber(formData){

        for(let i=0; i<this.state.students.length; i+=1){
            if(this.state.students[i].id === this.state.quickEditStudentMobile.id){
                if(this.state.students[i].metaData){
                    this.state.students[i].metaData.mobile = formData.mobile;
                }
                else{
                    this.state.students[i].metaData = {
                        mobile:formData.mobile
                    };
                }
                this.setState({});
                break;
            }
        }


        const apiPath = `${process.env.REACT_APP_API_URL}/studentupdate/mobile${this.state.ghostContact ? `/${this.state.ghostContact.id}` : ''}`;

        const payload = formData;
        payload.studentId = this.state.quickEditStudentMobile.id;
        axios.post(apiPath,payload,{
            timeout: 30000,
            withCredentials:true
        }).catch(err => {
            console.warn(err);
        });

    }



    restartBooking(){
        this.state.bookingData.legs = [];
        this.state.legIndex = -1;
        this.setSlide('setTripEnd');
    }
    
    
    render() {
        return (
            <BookingsFlowContext.Provider value={{
                ...this.state,
                setState:this.setState.bind(this),
                getTravelDates: this.getTravelDates.bind(this),
                setTravelDateId: this.setTravelDateId.bind(this),
                setTravelDateCore: this.setTravelDateCore.bind(this),
                setTravelDate:this.setTravelDate.bind(this),
                setHolidayId: this.setHolidayId.bind(this),
                setAdhocTravelDate: this.setAdhocTravelDate.bind(this),
                setSlide: this.setSlide.bind(this),
                getNoStudentsTravelling : this.getNoStudentsTravelling.bind(this),
                setStudentTravelling: this.setStudentTravelling.bind(this),
                setDestinationOrigin: this.setDestinationOrigin.bind(this),
                setSchoolAddressId: this.setSchoolAddressId.bind(this),
                setLegDestination: this.setLegDestination.bind(this),
                rewindLeg: this.rewindLeg.bind(this),
                setLegTravelMode: this.setLegTravelMode.bind(this),
                toggleDriverType:this.toggleDriverType.bind(this),
                confirmCarReg:this.confirmCarReg.bind(this),
                finaliseLeg:this.finaliseLeg.bind(this),
                isDriverDataComplete:this.isDriverDataComplete.bind(this),
                goBack:this.goBack.bind(this),
                getTravelObject:this.getTravelObject.bind(this),
                setStayingAtHomeOpen:this.setStayingAtHomeOpen.bind(this),
                isLegOrigin:this.isLegOrigin.bind(this),
                isLegDestination:this.isLegDestination.bind(this),
                getLegStartAddress:this.getLegStartAddress.bind(this),
                getLegEndAddress:this.getLegEndAddress.bind(this),
                getLegOrigin:this.getLegOrigin.bind(this),
                getFriendlyAddress:getFriendlyAddress.bind(this),
                getFriendlyAddressForPointAtIndex:this.getFriendlyAddressForPointAtIndex.bind(this),
                getPrevLeg:this.getPrevLeg.bind(this),
                travelModeSlideSetup:this.travelModeSlideSetup.bind(this),
                travelOptionChecks:this.travelOptionChecks.bind(this),
                testedTravelCoaches:this.testedTravelCoaches.bind(this),
                testTravelModes:this.testTravelModes.bind(this),
                lastLegDestinationTime:this.lastLegDestinationTime.bind(this),
                addLeg:this.addLeg.bind(this),
                takeTheTrainFastTrack:this.takeTheTrainFastTrack.bind(this),
                getLegById:this.getLegById.bind(this),
                getLeg:this.getLeg.bind(this),
                checkPrivateTaxiShareCode:this.checkPrivateTaxiShareCode.bind(this),
                getLegByIdWithOrigin:this.getLegByIdWithOrigin.bind(this),
                updateMobileNumber:this.updateMobileNumber.bind(this),
                saveBooking:this.saveBooking.bind(this),
                getTravelObjectWithReversal:this.getTravelObjectWithReversal.bind(this),
                userConfirmAction:this.userConfirmAction.bind(this),
                restartBooking:this.restartBooking.bind(this),
                testTrainOption:this.testTrainOption.bind(this),
                testFlyingOption:this.testFlyingOption.bind(this),
                toggleParentBooker:this.toggleParentBooker.bind(this),
                setStudentRequiresCatering:this.setStudentRequiresCatering.bind(this),
                newBooking:this.newBooking.bind(this)
                }}>
                {this.props.children}
            </BookingsFlowContext.Provider>
        )
    }
}
export default BookingsFlowContextProvider;